import gql from 'graphql-tag';

export const findStudentInformationByCode = gql`
  query findStudentInformationByCode($studentCode: String!) {
    administrator {
      studentByCode(studentCode: $studentCode) {
        completeName
        dni
        firstName
        lastName
        studentCode
        studentId
        campus
      }
    }
  }
`;
